module.exports = __webpack_public_path__ + "static/media/CoconutPalm.8f550fe4.jpg";